// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import {
  HappyScroll
} from 'vue-happy-scroll'
// 引入css，推荐将css放入main入口中引入一次即可。
import 'vue-happy-scroll/docs/happy-scroll.css'
// //全局注册
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI)

import 'element-ui/lib/theme-chalk/index.css';
import {
  DatePicker,
  TimePicker,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Pagination,
  Row,
  Col,
  Icon,
  Tabs,
  Table,
  TableColumn,
  TabPane,
  Popover,
  Tooltip,
  Carousel,
  CarouselItem,
  Image,
  Message,
  MessageBox,
  Button,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Dialog,
  InputNumber,
  Steps,
  Step,
  Upload,
  Calendar,
  Autocomplete,
  Statistic,
  Loading
} from "element-ui";
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Pagination);
Vue.use(Loading.directive);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Input);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dialog);
Vue.use(TimePicker);
Vue.use(DatePicker);
Vue.use(InputNumber);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Upload);
Vue.use(Calendar);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Autocomplete);
Vue.use(Statistic);


import '@/common/flexible.js';

import * as echarts from 'echarts';

import geoJson from '@/utils/china.json'
echarts.registerMap('china', geoJson);

import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
Vue.use(vuescroll);
Vue.config.productionTip = false


//引入vant
// import Vant from 'vant'
// import 'vant/lib/index.css'
// Vue.use(Vant)
import 'vant/lib/index.css'
import {
  Button as VButton,
  DropdownMenu,
  DropdownItem,
  Popover as Popover1,
  Cell,
  CellGroup,
  PullRefresh,
  List,
  Skeleton,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  Icon as VIcon,
  Collapse,
  CollapseItem,
  Sticky,
  Popup,
  Tab,
  Toast,
  Tabs as Tabs1
} from "vant";
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(VButton);
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VIcon);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Sticky);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs1);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Skeleton);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Popover1);
Vue.use(Toast);
// // 按需全局引入 vant组件
// import Vue from 'vue'
// import {List, Cell, Tabbar, TabbarItem,Overlay
//   Lazyload } from 'vant'
// import 'vant/lib/index.css';

// Vue.use(Cell)
// Vue.use(List)

// Vue.use(Overlay)

// Vue.use(Lazyload)
// Vue.use(Tabbar).use(TabbarItem)





//引入swiper
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(vueSwiper)

import * as imageConversion from 'image-conversion'


import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// import vueMiniPlayer from 'vue-mini-player'
// import 'vue-mini-player/lib/vue-mini-player.css'
// Vue.use(vueMiniPlayer)

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import Api from './utils/request1.js';

Vue.prototype.$api = Api



var pcRoute = [
  'overview',
  'navigation',
  'knowledge',
  'information',
  'consult',
  'eduActivity',
  'cinema',
  'personCenter',
  'member',
  'login',
  'password',
  'register',
  'volunteer'
]
var mRoute = [
  'mIndex',
  'moverview',
  'mnavigation',
  'mknowledge',
  'mconsult',
  'meduActivity',
  'minformation'
]


let uRoute = router.options.routes
let mwRoute = []
let pcwRoute = []

let mwRoute1 = []
let pcwRoute1 = []

uRoute.forEach(item => {
  if (item.path.slice(0, 2) == '/m' && item.path != '/member') {
    mwRoute.push(item)
  } else {
    pcwRoute.push(item)
  }
})

mwRoute.forEach(item => {
  mwRoute1.push(item.path)
  if (item.children) {
    item.children.forEach(item1 => {
      mwRoute1.push(item.path + '/' + item1.path)
    })
  }
})

pcwRoute.forEach(item => {
  pcwRoute1.push(item.path)
  if (item.children) {
    item.children.forEach(item1 => {
      pcwRoute1.push(item.path + '/' + item1.path)
    })
  }
})


router.beforeEach((to, from, next) => {
  var ismobile = ''
  if (ismobile == '') {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )

    ismobile = flag ? 1 : 0
  }
  // 电脑
  if (ismobile == 0) {
    if (from.path == (window.location.pathname)) {
      next()
    } else {
      if (window.location.pathname.split('/')[1]) {
        if (pcwRoute1.indexOf(window.location.pathname) != -1) {
          next()
        } else {
          if (mwRoute1.indexOf(window.location.pathname) != -1) {
            if (pcwRoute1.indexOf("/" + window.location.pathname.slice(2)) != -1) {
              if (window.location.pathname == "/" || to.path == "/" + window.location.pathname.slice(2)) {
                next()
              } else {
                if (window.location.search) {
                  var obj = {};
                  var arr = window.location.search.split('?').pop().split('#').shift().split('&');
                  for (var i = arr.length - 1; i >= 0; i--) {
                    var k = arr[i].split('=')[0];
                    var val = arr[i].split('=')[1];
                    obj[k] = val;
                  }
                  next({
                    path: "/" + window.location.pathname.slice(2),
                    query: obj,
                    replace: true
                  })
                } else {
                  next({
                    path: "/" + window.location.pathname.slice(2),
                    replace: true
                  })
                }
              }
            } else {
              if (to.path == "/") {
                Message('暂无页面，请使用移动端打开')
                next()
              } else {
                next({
                  path: "/"
                })
              }
            }
          } else {
            if (to.path == "/") {
              Message('暂无页面')
              next()
            } else {
              next({
                path: "/"
              })
            }
          }
        }
      } else {
        next()
      }
    }

  } else if (ismobile == 1) {
    if ((from.path == (window.location.pathname))) {
      if (from.path.split('/')[1]) {
        if (pcwRoute1.indexOf(from.path) != -1) {
          if (to.path == "/mIndex") {
            next()
          } else {
            next({
              path: "/mIndex"
            })
          }
        } else {
          next()
        }
      } else {
        if (to.path == "/mIndex") {
          next()
        } else {
          next({
            path: "/mIndex"
          })
        }
      }
    } else {
      if (window.location.pathname.split('/')[1]) {
        if (mwRoute1.indexOf(window.location.pathname) != -1) {
          next()
        } else {
          if (pcwRoute1.indexOf(window.location.pathname) != -1) {
            if (mwRoute1.indexOf("/m" + window.location.pathname.slice(1)) != -1) {
              if (window.location.pathname == "/" || to.path == "/m" + window.location.pathname.slice(1)) {
                next()
              } else {
                if (window.location.search) {
                  var obj = {};
                  var arr = window.location.search.split('?').pop().split('#').shift().split('&');
                  for (var i = arr.length - 1; i >= 0; i--) {
                    var k = arr[i].split('=')[0];
                    var val = arr[i].split('=')[1];
                    obj[k] = val;
                  }
                  next({
                    path: "/m" + window.location.pathname.slice(1),
                    query: obj,
                    replace: true
                  })
                } else {
                  next({
                    path: "/m" + window.location.pathname.slice(1),
                    replace: true
                  })
                }
              }
            } else {
              if (to.path == "/mIndex") {
                Toast('暂无页面,请使用PC端打开')
                next()
              } else {
                next({
                  path: "/mIndex"
                })
              }
            }
          } else {
            if (to.path == "/mIndex") {
              Toast('暂无页面')
              next()
            } else {
              next({
                path: "/mIndex"
              })
            }
          }
        }
      } else {
        if (to.path == "/mIndex") {
          next()
        } else {
          next({
            path: "/mIndex"
          })
        }
        // next()
      }
    }

  } else {
    next();
  }
})

new Vue({
  el: '#app',
  // i18n,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js